import type { State } from '../../../../Flux/Slice/index.ts'
import { createSelector } from '@reduxjs/toolkit'
import type { VisualizationPipeline } from '../../SampleGrouping/RunPipeline.ts'

export const selectScope = (s: typeof State) => s.visualization.scope
export const selectProject = (s: typeof State) => s.project
export const selectOrder = (s: typeof State) => s.order
export const selectSource = (s: typeof State, sourceId: string) => s.visualization.sources[sourceId]

export const DEFAULT_PIPELINE: VisualizationPipeline = {
  filters: [],
  projections: [],
  groupBys: [],
  sortBys: []
}

export const EMPTY_KEYS: string[] = []

/* use a memoized selector to ensure least possible rerendering */
export const makeSelectVizBits = () =>
  createSelector([selectSource, selectScope, selectProject, selectOrder], (src, scope, project, order) => {
    let samplesLoading = false
    let ordersLoading = false

    if (scope?.kind === 'project') {
      samplesLoading = project.samplesLoading
      ordersLoading = project.projectOrders === 'LOADING'
    } else if (scope?.kind === 'order') {
      samplesLoading = order?.samplePools === 'LOADING'
      ordersLoading = false
    }

    return {
      sourceExists: !!src,
      storePipeline: src?.config?.pipeline ?? DEFAULT_PIPELINE,
      storeSelectedKeys: src?.state?.selectedBucketKeys ?? EMPTY_KEYS,
      fieldsIndex: src?.snapshot?.metadataIndex ?? null,
      samplesLoading,
      ordersLoading,
      status: src?.status ?? 'init'
    }
  })
